<template>
    <v-btn-toggle v-model="toggle_exclusive" rounded class="mb-2">
        <v-btn value="reacondicionado" color="#9be51a" :disabled="toggle_exclusive == 'reacondicionado'">
            <span class="buttonMenu">Reacondicionados</span>
        </v-btn>
        <v-btn value="informacion" color="#9be51a" :disabled="toggle_exclusive == 'informacion'">
            <span class="buttonMenu">Consultar reparación</span>
        </v-btn>
    </v-btn-toggle>
</template>

<script>

    export default {
        data: () => ({
            toggle_exclusive: "",
        }),

        methods: {
            cambiarInfo() {
                this.$router.push('/informacionReacondicionado')
            },
            cambiarReacondicionado() {
                this.$router.push('/reacondicionado')
            }
        },

        computed: {

        },

        watch: {
            toggle_exclusive(newVal) {
                if (newVal == "reacondicionado") {
                    this.cambiarReacondicionado();
                } else {
                    this.cambiarInfo();
                }
            }
        },

        created() {
            let url = window.location.pathname

            if (url == "/reacondicionado") {
                this.toggle_exclusive = "reacondicionado"
            } else {
                this.toggle_exclusive = "informacion"
            }
        }
    };

</script>

<style>
    @font-face {
        font-family: "TitilliumWeb";
        src: url("/font/titilliumweb-bold-webfont.woff2") format("woff2"), url("/font/titilliumweb-bold-webfont.woff") format("woff");
        font-weight: bolder;
        font-style: normal;
    }

    @font-face {
        font-family: "TitilliumWeb";
        src: url("/font/titilliumweb-regular-webfont.woff2") format("woff2"), url("/font/titilliumweb-regular-webfont.woff") format("woff");
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: "TitilliumWeb";
        src: url("/font/titilliumweb-semibold-webfont.woff2") format("woff2"), url("/font/titilliumweb-semibold-webfont.woff") format("woff");
        font-weight: bold;
        font-style: normal;
    }
</style>